<template>
	<div>
		<modalconfirm ref="modalSave" @action="saveSetting"/>
		<div class="text-h5">Setting Minimum BV Belanja Stockist</div>
		<v-col cols="6">
            <v-card class="mt-3" outlined>
				<v-card-text class="pt-2 pb-0">
                    <v-row>
                        <v-col cols="12" style="color: red;">
							* Harap hanya melakukan perubahan pada pukul 03:30 - 05:30 WIB
						</v-col>
					</v-row>
				</v-card-text>
                <v-card-text class="pt-2">
                    <v-row>
                        <v-col cols="12">
                            <v-currency-field v-model="discountSetting.discount_value" hint="Diskon dalam persen (%). Masukkan angka 1-100" persistent-hint :max="100" class="py-2 details-mb-0" outlined dense hide-details="auto" background-color="white" @focus="() => responseError.discount=''" :error-messages="responseError.discount" :decimalLength="2"></v-currency-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-currency-field v-model="discountSetting.rebate_value" hint="Potongan dalam rupiah (Rp.)" persistent-hint class="py-2 details-mb-0" outlined dense hide-details="auto" background-color="white" @focus="() => responseError.rebate=''" :error-messages="responseError.rebate" :decimalLength="2"></v-currency-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="px-4 pb-4">
                    <v-spacer></v-spacer>
                    <v-btn color="primary darken-1" :disabled="discountSetting.discount_value == '' || discountSetting.rebate_value == ''" depressed class="text-capitalize" @click="sync">Simpan</v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
	</div>
</template>

<script>

import {mapState, mapActions, mapMutations} from 'vuex'

export default {
	inject: ['theme'],
	components: {
	},
	data() {
		return {
			discount: 0,
			rebate: 0,
		}
	},
	props: {
	},
	computed: {
		...mapState('selfOrder', ['discountSetting', 'responseError']),
	},
	methods: {
		...mapActions('selfOrder', ['getSelfOrderDiscount', 'saveDiscountSelfOrder']),
		...mapMutations(['setOverlay']),

		sync() {
			let msg = `Yakin ingin menyimpan data?`
			this.$refs.modalSave.showConfirm()
			this.$refs.modalSave.setMessage(msg)
		},
		async saveSetting() {
			await this.setOverlay(true)
			await this.$refs.modalSave.hideConfirm()
			let params = await {
				discount: this.discountSetting.discount_value,
				rebate: this.discountSetting.rebate_value
			}

			await this.saveDiscountSelfOrder(params).then(() => {
				this.resetForm()
			})
			await this.setOverlay(false)
		},
		resetForm() {
			this.getBV()
		},
		async getBV() {
			await this.getSelfOrderDiscount().then((response) => {
				//console.log(response)
                this.bv = response.options_value
			}).catch(() => {
				//console.log(response)
			})
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', `Setting Diskon & Potongan Harga Self Order`)
		this.getBV()
	},
	beforeDestroy() {
	},
	watch: {
		
	}
}
</script>